import { makeRequestAction } from './index';

export const fetchRateMarketingInputs = makeRequestAction('FETCH_RATE_MARKETING_INPUTS', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const addOrUpdateRateMarketingInputs = makeRequestAction('ADD_OR_UPDATE_RATE_MARKETING_INPUTS', {
  onSuccess(params, response) {
    return { response };
  },
});
